module.exports = __webpack_public_path__ + "img/logo-console.2f735ba0.svg";